
let accountMsgBody = ""; // 已发送的订阅信息 (防止订阅相同信息)
export const myTransactionSocket = {
  methods: {
    // sendMsgStr 发送的订阅消息 MsgBody
    socketTransaction(sendMsgStr = "") {
      // 订阅订单状态信息
      let token = localStorage.getItem("token");
      if (token && sendMsgStr) {
        token = "Bearer " + token;
        if (!accountMsgBody) {
          accountMsgBody = sendMsgStr;
          this.$transSocket.sendMsg({
            MsgType: "SubNtf",
            MsgBody: accountMsgBody,
            Token: token
          });
        } else {
          if (accountMsgBody !== sendMsgStr) {
            // 如果有信息 先取消掉
            this.$transSocket.sendMsg({
              MsgType: "UnSubNtf",
              MsgBody: accountMsgBody,
              Token: token
            });
            accountMsgBody = sendMsgStr;
            this.$transSocket.sendMsg({
              MsgType: "SubNtf",
              MsgBody: accountMsgBody,
              Token: token
            });
          }
        }
      }
    }
  }
};
